export class GamingHistoryFilterParamItem {
	Column: string;
	Value: string;

	constructor(column: string, value: string) {
		this.Column = column;
		this.Value = value;
	}
}
